
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AppConfigService } from '../app-config.service';

@Injectable({ providedIn: 'root' })

export class AzureAppInsightsService {
  
  constructor(
    private appConfigService: AppConfigService,
    private router: Router
  ) {
    // IF WE HAVE APP INSIGHTS BOOLEAN FLAG ENABLED IN OUR CONFIG THEN INIT APP-INSIGHTS....
    if(this.appConfigService.IsAppInsightsEnabled) {
      this.appInsights.loadAppInsights();
      this.appInsights.trackPageView();
    }
  }


  private angularPlugin = new AngularPlugin();


  public appInsights = new ApplicationInsights({
    config: {
      connectionString: this.appConfigService.AppInsightsConnectStr,
      extensions: [this.angularPlugin],
      extensionConfig: {
        [this.angularPlugin.identifier]: { router: this.router }
      }
    }
  });


}